enum FilterKey {
  Assets = 'assets',
  AssetUnits = 'assetUnits',
  Basins = 'basins',
  Dates = 'dates',
  CaptureCost = 'captureCost',
  CcusDevelopmentStatuses = 'ccusDevelopmentStatuses',
  CcusProjects = 'ccusProjects',
  CcusProjectScales = 'ccusProjectScales',
  CcusProjectTypes = 'ccusProjectTypes',
  CcusSeparationTypes = 'ccusSeparationTypes',
  CcusStorages = 'ccusStorages',
  CO2Concentration = 'cO2Concentration',
  Companies = 'companies',
  CompaniesBuyer = 'companiesBuyer',
  CompaniesSeller = 'companiesSeller',
  CompanyTargets = 'companyTargets',
  Countries = 'countries',
  DevelopmentStatuses = 'developmentStatuses',
  DevelopmentTypes = 'developmentTypes',
  EventType = 'eventType',
  Facilities = 'facilities',
  FacilityTotalCO2Emissions = 'facilityTotalCO2Emissions',
  Formations = 'formations',
  Geologies = 'geologies',
  HasAbatement = 'hasAbatement',
  Hydrocarbons = 'hydrocarbons',
  Industries = 'industries',
  IncludeHistoricalParticipants = 'includeHistoricalParticipants',
  HasMaTransactions = 'hasMaTransactions',
  IsMAndAOpportunity = 'isMAndAOpportunity',
  NpvMax = 'npvMax',
  NpvMin = 'npvMin',
  Operator = 'operator',
  NonOperator = 'nonOperator',
  Opportunities = 'opportunities',
  CompanyOperand = 'companyOperand',
  ProductionMax = 'productionMax',
  ProductionMin = 'productionMin',
  ReservesMax = 'reservesMax',
  ReservesMin = 'reservesMin',
  DepthMax = 'depthMax',
  DepthMin = 'depthMin',
  ResourceThemes = 'resourceThemes',
  ShoreStatuses = 'shoreStatuses',
  StorageBlockStatuses = 'storageBlockStatuses',
  StorageCost = 'storageCost',
  StorageShoreStatuses = 'storageShoreStatuses',
  StorageSites = 'storageSites',
  StorageTypes = 'storageTypes',
  TotalAbatementCost = 'totalAbatementCost',
  TransportationCost = 'transportationCost',
}

enum FilterLabel {
  Assets = 'Asset/Block',
  AssetUnits = 'Asset Units',
  EffectiveDate = 'EFFECTIVE DATE (YEARS)',
  Basins = 'Basin',
  Block = 'Block',
  CaptureCost = 'Capture Cost US$/t',
  CcusDevelopmentStatuses = 'Development Status',
  CcusProjects = 'CCUS Project',
  CcusProjectTypes = 'Project Type',
  CcusProjectScales = 'Project Scale',
  CcusSeparationTypes = 'Separation Type',
  CO2Concentration = 'CO2 Concentration (Units)',
  Companies = 'Company',
  CompaniesSeller = 'Seller',
  CompaniesBuyer = 'Buyer',
  CompanyTargets = 'Company Targets',
  Countries = 'Country / Area',
  DevelopmentStatuses = 'Development Status',
  DevelopmentTypes = 'Development Type',
  DimCompanies = 'Company',
  EventType = 'Event Type',
  Facilities = 'Facility',
  FacilityTotalCO2Emissions = 'Facility Total CO2 Emissions (MMTPA)',
  Formations = 'Formation',
  Geologies = 'Reservoir Age',
  HasAbatement = 'Has Abatement Model',
  Hydrocarbons = 'Hydrocarbon',
  Industries = 'Industry',
  IncludeHistoricalParticipants = 'Historical Participants',
  NpvMax = 'NPV Max',
  NpvMin = 'NPV Min',
  Operator = 'Operator',
  NonOperator = 'Non-Operator',
  CompanyOperand = 'Filter Type',
  Opportunities = 'M&A Opportunities',
  ProductionMax = 'Production Max',
  ProductionMin = 'Production Min',
  ReservesMax = 'Reserves Max',
  ReservesMin = 'Reserves Min',
  DepthMax = 'Reservoir Depth Max',
  DepthMin = 'Reservoir Depth Min',
  ResourceThemes = 'Resource Theme',
  ShoreStatuses = 'Shore Status',
  StorageBlockStatuses = 'Block Status',
  StorageCost = 'Storage Cost US$/t',
  StorageShoreStatuses = 'Shore Status',
  StorageSites = 'Storage Site',
  StorageTypes = 'Storage Type',
  TotalAbatementCost = 'Total Abatement Cost US$/t',
  TransportationCost = 'Transportation Cost US$/t',
}

const FILTER_LABEL_MAP: Record<FilterKey, string> = {
  [FilterKey.Assets]: FilterLabel.Assets,
  [FilterKey.AssetUnits]: FilterLabel.AssetUnits,
  [FilterKey.Basins]: FilterLabel.Basins,
  [FilterKey.Dates]: FilterLabel.EffectiveDate,
  [FilterKey.CaptureCost]: FilterLabel.CaptureCost,
  [FilterKey.CcusDevelopmentStatuses]: FilterLabel.CcusDevelopmentStatuses,
  [FilterKey.CcusProjects]: FilterLabel.CcusProjects,
  [FilterKey.CcusProjectScales]: FilterLabel.CcusProjectScales,
  [FilterKey.CcusProjectTypes]: FilterLabel.CcusProjectTypes,
  [FilterKey.CcusSeparationTypes]: FilterLabel.CcusSeparationTypes,
  [FilterKey.CcusStorages]: FilterLabel.CcusSeparationTypes,
  [FilterKey.CO2Concentration]: FilterLabel.CO2Concentration,
  [FilterKey.Companies]: FilterLabel.Companies,
  [FilterKey.CompaniesBuyer]: FilterLabel.CompaniesBuyer,
  [FilterKey.CompaniesSeller]: FilterLabel.CompaniesSeller,
  [FilterKey.CompanyTargets]: FilterLabel.CompanyTargets,
  [FilterKey.Countries]: FilterLabel.Countries,
  [FilterKey.DevelopmentStatuses]: FilterLabel.DevelopmentStatuses,
  [FilterKey.DevelopmentTypes]: FilterLabel.DevelopmentTypes,
  [FilterKey.EventType]: FilterLabel.EventType,
  [FilterKey.Facilities]: FilterLabel.Facilities,
  [FilterKey.FacilityTotalCO2Emissions]: FilterLabel.FacilityTotalCO2Emissions,
  [FilterKey.Formations]: FilterLabel.Formations,
  [FilterKey.Geologies]: FilterLabel.Geologies,
  [FilterKey.HasAbatement]: FilterLabel.HasAbatement,
  [FilterKey.Hydrocarbons]: FilterLabel.Hydrocarbons,
  [FilterKey.Industries]: FilterLabel.Industries,
  [FilterKey.IncludeHistoricalParticipants]: FilterLabel.IncludeHistoricalParticipants,
  [FilterKey.HasMaTransactions]: FilterLabel.DevelopmentStatuses,
  [FilterKey.IsMAndAOpportunity]: FilterLabel.Opportunities,
  [FilterKey.NpvMax]: FilterLabel.NpvMax,
  [FilterKey.NpvMin]: FilterLabel.NpvMin,
  [FilterKey.Operator]: FilterLabel.Operator,
  [FilterKey.NonOperator]: FilterLabel.NonOperator,
  [FilterKey.Opportunities]: FilterLabel.Opportunities,
  [FilterKey.CompanyOperand]: FilterLabel.CompanyOperand,
  [FilterKey.ProductionMax]: FilterLabel.ProductionMax,
  [FilterKey.ProductionMin]: FilterLabel.ProductionMin,
  [FilterKey.ReservesMax]: FilterLabel.ReservesMax,
  [FilterKey.ReservesMin]: FilterLabel.ReservesMin,
  [FilterKey.DepthMax]: FilterLabel.DepthMax,
  [FilterKey.DepthMin]: FilterLabel.DepthMin,
  [FilterKey.ResourceThemes]: FilterLabel.ResourceThemes,
  [FilterKey.ShoreStatuses]: FilterLabel.ShoreStatuses,
  [FilterKey.StorageBlockStatuses]: FilterLabel.StorageBlockStatuses,
  [FilterKey.StorageCost]: FilterLabel.StorageCost,
  [FilterKey.StorageShoreStatuses]: FilterLabel.StorageShoreStatuses,
  [FilterKey.StorageSites]: FilterLabel.StorageSites,
  [FilterKey.StorageTypes]: FilterLabel.StorageTypes,
  [FilterKey.TotalAbatementCost]: FilterLabel.TotalAbatementCost,
  [FilterKey.TransportationCost]: FilterLabel.TransportationCost,
};

export { FilterKey, FilterLabel, FILTER_LABEL_MAP };
